import request from '@/utils/request'
import airDropRequest from '@/utils/airDropRequest'
import { getContractAbiRequest } from '@/utils/contract-abis'

// get login user info
export function getInfo() {
  return request({
    url: '/api/user/currentUser',
    method: 'get'
  })
}
export function getNonce(query) {
  return request({
    url: '/api/getNonce',
    method: 'get',
    params: query
  })
}

export function getAccountList(address) {
  return request({
    url: '/api/getAccountList?address=' + address,
    method: 'get'
  })
}

export function handleLogin(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

// 获取合约地址和abi
export function getContract(name) {
  const abiRequest = getContractAbiRequest(name)
  return airDropRequest({
    url: abiRequest.url,
    method: 'get',
    params: abiRequest.params
  })
}
